import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray,AbstractControl } from '@angular/forms';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { KitchenStockRequirementService } from 'app/shared/services/kitchen-stock-requirement.service';
import { KitchenStockItemService } from 'app/shared/services/kitchen-stock-item.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';




@Component({
  selector: 'ngx-stock-requirement',
  templateUrl: './stock-requirement.component.html',
  styleUrls: ['./stock-requirement.component.scss']
})
export class StockRequirementComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;


  filteredTypeList : any[]=[];

   crud_access = {
     read: null,
     create: null,
     approve: null,
     delete: null,
     createReceipt:null,
    };

  stockRequirement : any;

  itemList : any[]=[];

  searchKey : string = null;


  form: FormGroup;
  isfieldReadOnly : boolean= true;
  isfieldReceivedReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isHideBtn: boolean= false;
  isShowAttachBtn: boolean=false;
  isActionBtnShow = false;
  isShowPayBtn: boolean=false;
  isCancelBtnDisabled : boolean= false;
  isChangeOrderBtnDisabled : boolean= false;
  showInvoicePmtDetails : boolean= false;
  bsClassToShow : boolean = false;
  isEditDiscRate : boolean = false;
  selectChkBox : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  companyData : any  = [];
  logo :any;

  hasUpdateDocNo : boolean = false;

  validationMessages = {
    'docDate': { 'required': 'Document date is required' },
  };

  formErrors = {
    'docDate': "",
  };


  constructor(private fb: FormBuilder,
        private kitchenStockRequirementService: KitchenStockRequirementService,
        private kitchenStockItemService: KitchenStockItemService,
        private fileUploadService:FileUploadService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private route : ActivatedRoute,
        private router : Router,     
        private decimalPipe: DecimalPipe,
        private companyProfileService: CompanyProfileService,
        private themeService: NbThemeService )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });
      }

  ngOnInit() {
     const hasDocNo=  this.route.snapshot.queryParamMap.has('documentNo')
     this.hasUpdateDocNo=  this.route.snapshot.queryParamMap.has('updateDocNo')
      this.initInvoceType();
      this.initFormFields();
      this.getCompanyDetails();
      
      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;
      this.disableForm();

      if(this.kitchenStockRequirementService.orderItems.length > 0 && !hasDocNo){
        this.loadKitchenStockRequirementData();
      }
      
      if(hasDocNo){
        this.viewInvoiceById();
      }
     
      

      this.getControlPermissions();
  

      this.form.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.form);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

           

  }// end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='KS'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }

  }

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }


    

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;   
                this.loadLogo();         

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }
  



  initInvoceType() : void{

    this.stockRequirement = {
      id : null,
      docNo: '',
      docDate: '',
 
      item: '',
      unit: '',
      qtyInStock: 0.00,
      qty:  0.00,
      totalQty:  0.00,
      unitCost:  0.00,
      totalCost:  0.00,

      grandTotal: 0.00,
      status : '',
      createdBy : '',

    };

  }


  initFormFields() : void{
    this.form = this.fb.group({
      id : [null],
      docNo : [null],
      docDate : [this.defaultDate,Validators.required],
      invoiceItems : this.fb.array([]), 
       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.selectChkBox= false;
    this.isBtnDisabled = false;
    this.isActionBtnShow= false;
    this.isHideBtn = false;
    this.isShowAttachBtn=false;
    this.isShowPayBtn=false;
    this.isCancelBtnDisabled = true;
    this.form.reset();
    this.resetOtherControls();
    this.enableForm();
    this.form.patchValue({
      docDate:  this.defaultDate
    });
     
   }

  
   
   get getInvoiceItems(){
      return this.form.get('invoiceItems') as FormArray;
   }

   

   loadKitchenStockRequirementData() : void {
    this.getInvoiceItems.clear();  
       var data= this.kitchenStockRequirementService.orderItems;
          if(data.length > 0){
            this.newButtonClick(); 
              if(this.hasUpdateDocNo){
                const documentNo = this.route.snapshot.queryParamMap.get('updateDocNo')
                this.form.patchValue({docNo: documentNo});
              }     
              this.form.setControl('invoiceItems',this.loadKitchenStockItems(data));
              this.updateBillTotal();  
              this.isfieldReadOnly = true;     
          }  
      }
   
  


 loadKitchenStockItems(data) : FormArray{
  const invoiceItemArray = new FormArray([]);
  for(let i =0; i < data.length;i++){ 
    invoiceItemArray.push(this.fb.group({
      itemId: [data[i].Id,Validators.required],
      item : [data[i].Name,Validators.required],
      unit : [data[i].Unit,Validators.required],
      qtyInStock: [data[i].QtyBal,Validators.required],
      qty : [data[i].Qty,Validators.required],
      totalQty : [data[i].TotalQty,Validators.required],
      unitCost : [data[i].UnitCost,Validators.required],
      totalCost : [data[i].TotalCost,Validators.required],  
     
    }));
  }
  return invoiceItemArray;
}




    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }


        this.stockRequirement.grandTotal = 0.00;
        this.stockRequirement.status = null;
        this.showInvoicePmtDetails = false;
        this.bsClassToShow = false;
       
    }

    isNumeric(value) {
      if (!isNaN(value) &&  !isNaN(parseFloat(value))) {
        return true;
      }
       return false;
  
    }
  
  
  updateBillTotal(){
    this.stockRequirement.grandTotal = +this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.totalCost, 0);

  }

  removeItemButtonClick(itemIndex : number,row:any) : void{
    this.getInvoiceItems.removeAt(itemIndex);
    const arr = this.kitchenStockRequirementService.orderItems;
    var i = arr.length;

    while(i--){
      if( arr[i]  && arr[i].Id === row.value.itemId ) {   
          arr.splice(i,1);
      }         
   }
   this.kitchenStockRequirementService.orderItems = arr;
   this.updateBillTotal();

  
  }


  mapFormValuesToModel(){
    let data =[];
    let finalData = [];

    for(let i=0; i < this.getInvoiceItems.length; i++){

    this.stockRequirement.docDate=this.form.value.docDate;

    this.stockRequirement.item = this.getInvoiceItems.value[i].itemId
    this.stockRequirement.unit=this.getInvoiceItems.value[i].unit;
    this.stockRequirement.qtyInStock=this.getInvoiceItems.value[i].qtyInStock;
    this.stockRequirement.qty=this.getInvoiceItems.value[i].qty;
    this.stockRequirement.totalQty=this.getInvoiceItems.value[i].totalQty;
    this.stockRequirement.unitCost =this.getInvoiceItems.value[i].unitCost;
    this.stockRequirement.totalCost=this.getInvoiceItems.value[i].totalCost;

    this.stockRequirement.grandTotal;
    this.stockRequirement.status='Posted';
    this.stockRequirement.createdBy =this.authService.getUserLoggedIn();
    
    data.push(
      this.stockRequirement.docDate,

      this.stockRequirement.item,
      this.stockRequirement.unit,
      this.stockRequirement.qtyInStock,
      this.stockRequirement.qty,
      this.stockRequirement.totalQty,
      this.stockRequirement.unitCost,
      this.stockRequirement.totalCost,

      this.stockRequirement.grandTotal,
      this.stockRequirement.status,
      this.stockRequirement.createdBy,

      );

    }

    while(data.length){
      finalData.push(data.splice(0,11));
    }
  
   return finalData

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.form,true);
 
    const data = this.mapFormValuesToModel();

    if(this.isFilledFromFields()){
      if(!this.form.value.docNo){
        this.showProcessingIndicator = true;
          this.kitchenStockRequirementService.create(data)
          .subscribe(
            (res) =>{               
                this.toastr.success('Record created successfully','Success');
                this.form.patchValue({docNo: res.docNo});
                this.kitchenStockRequirementService.orderItems = [];
                this.isfieldReadOnly  = true;
                this.isChangeOrderBtnDisabled = true;
                this.isBtnDisabled = true;
                this.isHideBtn = true;
                this.isShowAttachBtn = true;
                this.disableForm(); 
                this.showProcessingIndicator = false;   
               
                       
            },
            (err) =>{ 
              this.toastr.error('Failed to create record','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )

      }else{
        this.showProcessingIndicator = true;
        const docNo=this.form.value.docNo;
          this.kitchenStockRequirementService.update(docNo,data)
          .subscribe(
            (res) =>{               
                this.toastr.success('Record updated successfully','Success');
                this.kitchenStockRequirementService.orderItems = [];
                this.isfieldReadOnly  = true;
                this.isChangeOrderBtnDisabled = true;
                this.isBtnDisabled = true;
                this.isHideBtn = true;
                this.isShowAttachBtn = true;
                this.disableForm(); 
                this.showProcessingIndicator = false;   
               
                       
            },
            (err) =>{ 
              this.toastr.error('Failed to create record','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )
      }
    }

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }



   paidBtnClick(){
    if(this.isFilledFromFields()){
      let docNo = this.form.get('docNo').value;
      this.dialogService.openConfirmDialog('Are you sure you want to update the status this record?')
      .afterClosed().subscribe(res =>{
        if(res){
      this.kitchenStockRequirementService.updateStatus(docNo)
      .subscribe(
        (res) =>{               
            this.toastr.success('Record updated successfully','Success');
            this.isfieldReadOnly  = true;
            this.isBtnDisabled = true;
            this.isShowPayBtn = false;
            this.isCancelBtnDisabled = true;
            this.isChangeOrderBtnDisabled = true;
            this.disableForm(); 
            this.showProcessingIndicator = false;   
           
                   
        },
        (err) =>{ 
          this.toastr.error('Failed to create record','Failure'); 
          this.showProcessingIndicator = false;   
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      );
     }
    });
    }

   }

   deleteButtonClick(){   
    let docNo = this.form.get('docNo').value;
    if(docNo){
    this.dialogService.openConfirmDialog('Are you sure you want to cancel this record?')
    .afterClosed().subscribe(res =>{
      if(res){
     this.kitchenStockRequirementService.delete(docNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Record deleted successfully','Success');
                    this.router.navigate(['../stock-requirement-list'],{relativeTo : this.route});     
                
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete record','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}


changeOrderBtnClicked(){
 const documentNo = this.form.get('docNo').value
  if(documentNo){
    this.router.navigate(['../add-stock-requirement'],{queryParams : {'updateDocNo':documentNo},relativeTo : this.route});  
  }else{   
    this.router.navigate(['../add-stock-requirement'],{relativeTo : this.route});  
  }
    
}

   enableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.form,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.form.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.form.value.cusId;
    if(!value){
      this.form.patchValue({ cusId :  null,cusName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getInvoiceItems.length==0 || this.form.get('invoiceItems').invalid){
            return false;
          }

        return true;
  }

 



    viewInvoiceById(){
        let hasDocumentNo;
        let documentNo;

        hasDocumentNo =this.route.snapshot.queryParamMap.has('documentNo');
         
          if(hasDocumentNo){
            documentNo = this.route.snapshot.queryParamMap.get('documentNo')
            this.kitchenStockRequirementService.getRequirement(documentNo)
            .subscribe(
              (data) => {
                        if(data){    
                          let data2 =data.map(v => ({...v, isEdit: true}))                     
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data2); 
                          this.isBtnDisabled = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;    
                          this.isHideBtn = true;                    
                          this.showInvoicePmtDetails = true;    
                          this.bsClassToShow = true;      
                          this.isShowAttachBtn = true;                  
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }

    }

patchValuesToForm(data){

  this.form.patchValue({  
    id: data[0].Id,
    docNo : data[0].DocNo,
    docDate : moment(data[0].DocDate).format("YYYY-MM-DD"),
  });
  
  this.form.setControl('invoiceItems',this.setInvoiceItems(data));  
  this.stockRequirement.grandTotal = data[0].GrandTotal,
  this.stockRequirement.status = data[0].Status;
  this.stockRequirement.createdBy = data[0].CreatedBy;


  if(data[0].Status==='Cancelled'){
    this.isCancelBtnDisabled = true;
    this.isChangeOrderBtnDisabled = true;
    this.isShowPayBtn = false;
  }

  if(data[0].Status==='Posted'){
    this.isShowPayBtn = true;
    this.isActionBtnShow= true;
    this.isChangeOrderBtnDisabled = false;
  }

  if(data[0].Status==='Paid'){
    this.isCancelBtnDisabled = true;
    this.isShowPayBtn = false;
    this.isChangeOrderBtnDisabled = true;
  }

  this.mapOrderItems(this.getInvoiceItems.value)
 // console.log(this.kitchenStockRequirementService.orderItems)
}

mapOrderItems(data){
  const itemList = data.map(item =>{
    return {
      Id: item.itemId,
      Name: item.item,
      Unit : item.unit,
      QtyBal: item.qtyInStock,
      Qty: item.qty,
      TotalQty: item.totalQty,
      UnitCost: item.unitCost,
      TotalCost: item.totalCost,
      CreatedBy: '',
      filled: true,

    }
  });

  this.kitchenStockRequirementService.orderItems = itemList;
}

  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemId: [data[i].ItemId],
        item : [data[i].Name],
        unit : [data[i].Unit],
        qtyInStock: [data[i].Qty],
        qty :  [data[i].ReqQty],
        totalQty : [data[i].TotalQty],
        unitCost : [data[i].UnitCost],
        totalCost : [data[i].TotalCost],
      
      }));
    }
    return invoiceItemArray;
  }




attachFileButtonClick(){
 this.fileUploadService.refNo = this.form.value.invoiceNo;
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = "75%";
   this.dialogService.openDialog(FileUploadComponent,dialogConfig)
   .afterClosed().subscribe(res => {
    //this.getAll()
   });  
 }





    savePDF(action){
     
      let invoiceNoBox = {type: 'rect',x: 0,  y: 0,  w: 120,  h: 30,lineColor: '#080808', r: 10};  
   
    const documentDefinition = { 
      pageSize: 'A4',
      pageOrientation: 'portrait',  
      pageMargins: [40, 40, 40, 60],
 
      content: [ 
          
        {
          columns : [ 
            
                  { image:this.logo,            
                    width: 120,
                    height: 120,
                  },                                                       
                  [
                    {
                      text: this.companyData[0].CompanyName,  
                      bold: true,
                      fontSize: 30,
                      alignment: 'right',
                    },
                    { text: this.companyData[0].Address,  alignment: 'right', },  
                    { text: this.companyData[0].Phone,  alignment: 'right', },  
                    { text: this.companyData[0].Email,  alignment: 'right', }  
                  ],   
           ]
   
        },   
        
        `\n`,

        { text: 'Kitchen Stock Requirement', style: 'reportHeader' }, 

        `\n`,

        {
          table: {
            widths: ['auto', 'auto','*','auto','auto'], 
            body: [
              [{text:'Document No',margin: [5, 0, 0, 0]},     {text: `: ${this.form.value.docNo}`,margin: [5, 0, 0, 0]},{text:'',margin: [5, 0, 0, 0]},{text:'Document Date',margin: [5, 0, 0, 0]}, {text:  `: ${moment(this.form.value.docDate).format("YYYY-MM-DD")}`,margin: [5, 0, 0, 0]}],
              [{text:'Create By',margin: [5, 0, 0, 0]},     {text: `: ${this.stockRequirement.createdBy}`,margin: [5, 0, 0, 0]},{text:'',margin: [5, 0, 0, 0]},{text:'Status',margin: [5, 0, 0, 0]},{text:`: ${this.stockRequirement.status}`,margin: [5, 0, 0, 0]}],
            ]
          },
          layout: 'noBorders'
        },
     
        '\n\n',
                           
        {  
          // layout: {
          //   defaultBorder: false,
          //   hLineWidth: function(i, node) {
          //     return 1;
          //   },
          //   vLineWidth: function(i, node) {
          //     return 1;
          //   },
          //   hLineColor: function(i, node) {
          //     if (i === 1 || i === 0) {
          //      return '#bfdde8';
          //     }
          //     return '#eaeaea';
          //   },
          //   vLineColor: function(i, node) {
          //     return '#eaeaea';
            
          //   },
          //   hLineStyle: function(i, node) {
          //     // if (i === 0 || i === node.table.body.length) {
          //    // return null;
          //     return '#DB4834';
          //     //}
          //   },
          //   // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
          //   paddingLeft: function(i, node) {
          //     return 10;
          //   },
          //   paddingRight: function(i, node) {
          //     return 10;
          //   },
          //   paddingTop: function(i, node) {
          //     return 2;
          //   },
          //   paddingBottom: function(i, node) {
          //     return 2;
          //   },
          //   fillColor: function(rowIndex, node, columnIndex) {
          //     return '#fff';
          //   },
            
          // },
          table: {  
              dontBreakRows: true, 
              widths: [ '*', 'auto','auto','auto','auto','auto', 'auto'],  
              body: [  
                [
                 { text: 'Item', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'Unit', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'QtyBal', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'RequiredQty', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'TotalQty', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'UnitCost', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]},
                 { text: 'TotalCost', style:'tableFont',fillColor: '#D2B4DE', border: [true, true, true, true],   margin: [0, 5, 0, 5]}],
                ...this.getInvoiceItems.value.map(p => ([{ text :p.item, border: [true, true, true, true],  margin: [0, 5, 0, 5],style:'tableFont'},{ text :p.unit, border: [true, true, true, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.qtyInStock), border: [true, true, true, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.qty), border: [true, true, true, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.totalQty), border: [true, true, true, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' }, { text: this.transformNumberFormat(p.unitCost), border: [true, true, true, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' },{ text: this.transformNumberFormat(p.totalCost), border: [true, true, true, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' }])),               
              ]           
        }       
      },

      '\n',
      '\n',
      {
        columns : [
                  {},
                       
              { 
                layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return '#eaeaea';
                },
                vLineColor: function(i, node) {
                  return '#eaeaea';
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return '#fff';
                },
              },
                width: 'auto', 
                fontSize: 12,            
                table: {
                dontBreakRows: true, 
                widths: ['auto', 'auto'],
                    body: [
                    [
                      {
                        text: 'GrandTotal',
                        bold: true,
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.stockRequirement.grandTotal),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],
                  ],
                },
              },         
        ]

      },

      '\n',
      '\n\n',
      '\n\n',

      {
        columns : [
       
          [          
            {alignment:'left',canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
            '\n',
            {text: 'Approved By', alignment: 'left', margin: [25, 5, 0, 5]},
          ],  
     
          [
            {alignment:'right',canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
            '\n',
            {text: 'Created By', alignment: 'right', margin: [0, 5, 20, 5]},
  
          ],    

        ]

      },

     
    

      // '\n','\n','\n',  
      // '\n','\n',

  ],  // end content

  

 
      styles: {  
        reportHeader: {  
            bold: true,  
            decoration: 'underline',  
            fontSize: 18,  
            margin: [0, 15, 0, 15],
            alignment: 'center',             
        },
        tableFont: {  
          fontSize: 10,  
           
      
        }       
    } 
      
      
     };// end 


      if(action==='open'){    
            pdfMake.createPdf(documentDefinition).open();  
          
        }else if(action === 'print'){    
            pdfMake.createPdf(documentDefinition).print();          
        }
        else if(action === 'download'){    
          pdfMake.createPdf(documentDefinition).download(`Stock Requirement-${this.form.value.docNo}`);     
      }
    }


   transformNumberFormat(number) {
    return this.decimalPipe.transform(number,'1.2-2');
   }

    } // end class
